import React from 'react';
import api from 'api';

class Maintenance extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeId = this.handleChangeId.bind(this);
    this.handleChangeFile = this.handleChangeFile.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {};
  }
  render() {
    return (
      <div className="content-wrapper">
        <section className="content-header content-header-fixed">
          <h3 className="box-title">Update EML</h3>
        </section>
        <section className="content content-fixed">
          <div className="box box-primary">
            <br/>
            &nbsp; <input type="text" placeholder="Message id" onChange={ this.handleChangeId } />
            <br/>
            &nbsp; <input type="file" onChange={ this.handleChangeFile } accept=".eml" />
            <br/>
            &nbsp; <button type="button" className="btn btn-primary btn-sm" onClick={ this.handleSubmit } disabled={ !this.isValid() || this.props.loading || this.state.success }>Upload</button>
            <br/>
            {
              this.state.success
                ? <strong className="text-success">EML uploaded</strong>
                : null
            }
            {
              this.props.errorMessage
                ? <strong className="text-danger">Error: { this.props.errorMessage }</strong>
                : null
            }
          </div>
        </section>
      </div>
    )
  }
  handleChangeId(evt) {
    const message_id = evt.currentTarget.value;
    this.setState({ message_id });
  }
  handleChangeFile(evt) {
    const file = evt.currentTarget.files[0];
    this.setState({ file });
  }
  isValid() {
    return this.state.message_id && this.state.file;
  }
  handleSubmit() {
		const reader = new FileReader();
		reader.onload = () => {
      this.props.api.message.postData({
        url: `/${this.state.message_id}/update-eml`,
        data: { eml: reader.result }
      })
      .then(res => {
        if (res) this.setState({ success: true });
      });
    };
    reader.readAsText(this.state.file, 'UTF-8');
  }
}

export default api.connect(Maintenance, 'message');



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/containers/Maintenance.jsx